import FeaturedPostThumb from './FeaturedPostThumb';
import FeaturedPostThumbContainer from './FeaturedPostThumb.container';

export default FeaturedPostThumbContainer(FeaturedPostThumb);
